<template>
    <div>
        <navigation-bar Back Bell/>
        <div id="container" class="main chatroom">
            <div class="chatroom-head">
                <small class="d-flex justify-content-between">
                    <span>{{chatData.createdAt}}</span>
                    <span>{{chatData.typeName}}</span>
                </small>
                <div class="title">{{chatData.title}}</div>
                <small class="d-flex">
                    <img src="@/assets/images/store.svg" class="mr-1 fixed-w-20"/>
                    <span>{{chatData.brandName}} {{chatData.storeName}}</span>
                </small>

            </div>
            <div class="chatroom-body">
                <div class="commentItem"
                     v-for="(item, key) in chatReplyAry"
                     :key="key">
                    <div class="comment" :class="[(item.type===0)? 'comment-user':'comment-service']">
                        <div class="avatar">
                            <el-avatar :src="(item.type===0)? userImgUrl : storeImgUrl"/>
<!--                            <el-avatar v-else class="error">-->
<!--                                <img src="../../../assets/images/user.svg">-->
<!--                            </el-avatar>-->
                        </div>
                        <div class="comment-content">
                            <div>
                                {{ item.content }}
                            </div>
                            <div v-if="item.imageAry" class="content-img">
                                <ul class="contentImgList">
                                    <li v-for="(img, key) in item.imageAry"
                                        :key="key">
                                        <el-avatar
                                            shape="square"
                                            :size="100"
                                            :src="img"
                                            @click.native="onClickMsgImage(item.imageAry, key)"/>
                                    </li>
                                </ul>
                                <el-dialog :visible.sync="msgImageDialogVisible"
                                           class="stall-photo-pop">
                                    <Banner :list="msgImageAry"
                                            :fileNum="msgImagePreviewNum"
                                            :isDelete="false"
                                            @value-close="closeMsgImageDialog"/>
                                </el-dialog>
                            </div>
                        </div>
                        <small class="comment-footer">
                            <span v-if="item.branchName"> {{ item.branchName }} </span>
                            <span> {{ item.createdAt }} </span>
                        </small>
                    </div>
                </div>
            </div>

        </div>
        <div class="chatroom-footer" v-show="!isMessageClose">
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 1, maxRows: 4}"
                    class="border-input"
                    placeholder="輸入回覆內容..."
                    v-model="replyComment"/>

            <el-button type="text" @click="send">
                <img src="@/assets/images/send.svg"/>
            </el-button>

            <el-upload
                    action="#"
                    accept=".jpg, .png, .jpeg"
                    list-type="picture-card"
                    :limit="maxImageLimit"
                    :disabled="disableFilePicker"
                    :on-remove="handlePictureCardRemove"
                    :on-change="onFileChange"
                    :on-exceed="onFileMax"
                    :file-list="fileList"
                    :auto-upload="false"
                    :multiple="true"
                    class="upload-custom">
                <span class="no">5</span>
                <img slot="default" src="@/assets/images/images-line.svg"/>
                <div slot="file" slot-scope="{file}">
                    <el-image fit="cover" :src="file.url" @click.native="handlePictureCardPreview(file)"/>
                    <i class="el-icon-error delete-btn"  @click="handlePictureCardPreview(file)"/>
                </div>
            </el-upload>
            <el-dialog :visible.sync="pictureCardPreviewDialogVisible"
                       class="stall-photo-pop">
                <Banner :list="fileList"
                        :fileNum="pictureCardPreviewImgIndex"
                        @value-close="closePictureCardPreviewDialog"
                        @value-remove="handlePictureCardRemove"/>
            </el-dialog>
        </div>
        <comm-dialog :value="dialog.isShowDialog" :outerContent="dialog.dialogMsg"  :isCancel="dialog.cancelable" @result="onCommDialogClose"/>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>

</template>

<script>
    import Banner from '@/components/PhotoSlider';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import CommDialog from '@/components/CommDialog.vue';

    export default {
        name: "Chatroom",
        components: {
            Banner,
            Toast,
            CommDialog,
        },
        data() {
            return {
                isLoading: false,
                replyComment: "",
                sendButton: false,
                imageUploadButton: true,
                messageListId: Number(this.$route.query.messageListId? this.$route.query.messageListId: 0),        //訊息串的 ID
                chatData: {
                    brandImage:'',
                    title:'這是標題',
                    createdAt:'2020.06.11',
                    picture:'',
                    status:0,
                    storeName:'健康店',
                    brandName:'',
                    typeName:'問題',
                    contentAry:[],        //回覆的留言資料，拉到外面給 chatReplyAry用
                },
                chatReplyAry: [
                    {
                        // content:'這是標題',
                        // createdAt:'2020.06.11',
                        // imageAry:'',
                        // type:0,     //type, 0: 使用者回覆  1:店家回覆
                    },
                ],

                storeImgUrl: '',
                userImgUrl: '',
                isMessageClose: false,                      //留言板是否關閉？

                //留言列表的預覽圖片相關變數
                msgImageDialogVisible: false,               //留言列表 的圖片預覽控制旗標
                msgImagePreviewNum:'',                      //留言列表圖片預覽時的預覽圖片索引
                msgImageAry: [],                            //留言列表圖片預覽 的預覽圖片陣列，點擊以後才開始轉換

                //目前選中的預覽照片相關變數
                disableFilePicker: false,                   //是否停用上傳圖片按鈕？
                maxImageLimit: 5,                           //最大上傳圖檔數量
                fileList: [],                               //留言用到的圖檔

                pictureCardPreviewImgIndex: 0,              //回覆留言區域，要預覽的圖的索引
                pictureCardPreviewDialogVisible: false,     //回覆留言區域的圖片預覽控制旗標

                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
            };
        },
        created() {
            // this.messageListId = Number(this.$route.query.messageListId? this.$route.query.messageListId: 0);
        },
        mounted() {
            // this.callFeedbackLogInfoApi(69);
            this.callFeedbackLogInfoApi(this.messageListId);
        },
        methods: {
            setFocus() {
                this.sendButton = true;
                this.imageUploadButton = false;
            },

            /** 送出 */
            send: function() {
                let self = this;
                let isError = this.checkBeforeLeaveMessage(self.messageListId, self.replyComment, self.fileList);
                if ( isError === 0) {
                    this.reply(this.messageListId, this.replyComment, this.fileList);

                } else {
                    let errMsg = '';
                    if (isError === 1) {
                        errMsg = '留言ID錯誤，請重新進入本頁再留言';
                    } else if (isError === 4) {
                        errMsg = '請輸入留言內容或圖片';
                    }
                    this.$store.commit(mutationTypes.SHOW_TOAST, errMsg);
                }
            },

            /** 留言檢查 */
            checkBeforeLeaveMessage(messageListId, content, imgFileAry) {
                let error = 0;

                if (messageListId <= 0) {
                    error = 1;

                } else if ( (!this.$public.notNull(content) || content === '') &&
                    (!this.$public.notNull(imgFileAry) || imgFileAry.length === 0)) {
                    //內容空白也可以，但內容和圖片不能都是空
                    error = 4;
                }
                return error;
            },


            /** 文件狀態改變(新增、上傳成功和上傳失敗)時會呼叫 */
            onFileChange: async function(file, fileList) {
                //file結構: {"status":"ready","name":"dayelang.jpg","size":20297,"percentage":0,"uid":0,"raw":{"uid":0},"url":"blob:"}
                // console.log(`onFileChange fileList: ${JSON.stringify(fileList)}`);
                let self = this;

                //刪除重複檔案
                for(let i = 0; i < fileList.length - 1; i += 1) {
                    for(let j = 1; j < fileList.length; j += 1) {
                        if( (i!==j) && fileList[i].name === fileList[j].name) {
                            fileList.splice(j ,1);
                            break
                        }
                    }
                }
                self.fileList = fileList;
                self.disableFilePicker = (self.fileList.length >= self.maxImageLimit);

            },
            /** 移除圖檔 */
            handlePictureCardRemove(file) {
                // this.removeUploadImageFile(file);
                this.$delete(this.fileList, this.fileList.indexOf(file));
                this.disableFilePicker = (this.fileList.length >= this.maxImageLimit);
                // console.log(`handleRemove: \n file : ${JSON.stringify(file)} \n fileList : ${JSON.stringify(fileList)} \n selectImageAry : ${JSON.stringify(this.selectImageAry)}`);
            },
            /** 檔案數量上限 */
            onFileMax: function() {
                this.$store.commit(mutationTypes.SHOW_TOAST, `已超出張數上傳上限`);
            },

            /** 檢查檔案 */
            checkFile: async function (files) {
                // let files = e.target.files || e.dataTransfer.files;
                let self = this;
                let fileResults = [];       //檔案陣列

                // 預防檔案為空檔
                if (!files.length) {
                    return undefined;
                } else {

                    //上傳圖片
                    let loadImageFile = async (file) => {
                        await self.readFile(file)
                            .then((result) => {
                                return fileResults.push(result.file);
                            });
                    };

                    let asyncRun = async (fileList) => {
                        for (let file of fileList) {
                            await loadImageFile(file);
                        }
                    };

                    await asyncRun(files).then( () => {
                        return fileResults;
                    })
                }
                return fileResults;
            },

            /** 讀取檔案 */
            readFile: function(file, setImageWidth = 0, setImageHeight = 0) {
                let self = this;
                return new Promise((resolve) => {
                    let file_result = {
                        file: file,
                        imagePreview: '',
                        imageWidth: '',
                        imageHeight: '',
                        status: 'ok'
                    };

                    //檢查檔案大小
                    if (file.size > 2000000) {
                        file_result['status'] = 'size_too_big';
                        return;
                    }

                    let reader = new FileReader();
                    reader.onload = function () {
                        file_result["imagePreview"] = this.result;
                        if (setImageWidth !== 0 && setImageHeight !== 0) {
                            let image = new Image()
                            image.onload = function () {
                                file_result["imageWidth"] = image.width;
                                file_result["imageHeight"] = image.height;
                                // 檢查圖片尺寸
                                if (setImageWidth !== image.width || setImageHeight !== image.height) {
                                    file_result['status'] = 'out_of_size';
                                }
                            }
                            image.src = this.result;
                        }
                        // console.log(`FileReader: file_result : ${JSON.stringify(file_result)}`);
                        resolve(file_result);
                    };
                    // reader.readAsDataURL(file);
                    reader.readAsText(file.raw);
                })
            },

            /** 取得詳細回覆內容 */
            callFeedbackLogInfoApi : function(messageListId) {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetFeedbackLogInfoById${{
                        id: messageListId,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.chatData = json.data;

                            //預防品牌名稱是 null
                            if (!self.$public.notNull(self.chatData.brandName)) {
                                self.chatData.brandName = '';
                            }

                            self.chatReplyAry = json.data.contentAry;

                            //留言板已關閉
                            self.isMessageClose = (json.data.status === 1);
                            //頭像
                            self.storeImgUrl = json.data.brandImage;
                            self.userImgUrl = json.data.picture;

                            //畫面重整完以後執行
                            self.$nextTick(function () {
                                //重刷完成後
                                self.scrollToBottom();
                            });

                            //console.log(`confirmBookingUrl : ${self.confirmBookingUrl}`);
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 回覆留言 */
            reply: function (messageListId, content, imageAry) {
                let toUploadImageAry = [];
                let uploadedImageAry = [];
                let self = this
                //上傳圖片
                let uploadImageAry = () => {
                    return new Promise((resolve) => {
                        self.isLoading = true;
                        if (imageAry.length > 0) {

                            for (let imageFile of imageAry) {
                                toUploadImageAry.push(imageFile.raw);
                            }

                            self.$http.fetchUpload`${{
                                "file": toUploadImageAry,
                                "folder": "/commentPhoto"
                            }} ${json => {
                                self.isLoading = false;
                                if (json.status) {
                                    if (self.$public.notNull(json.data)) {
                                        json.data.forEach( (element, index) => {
                                            uploadedImageAry.push(element);
                                        });
                                    }
                                }
                                resolve();
                            }}`;
                        } else {
                            resolve();
                        }
                    });
                };
                //fetch 同步
                let asyncRun = async () => {
                    await Promise.all([uploadImageAry()])
                };

                //上傳圖片
                asyncRun().then( ()=>{
                    return self.callReplyFeedbackApi(messageListId, content, uploadedImageAry);
                })
            },

            /** 回覆留言 Api */
            callReplyFeedbackApi : function(messageListId, content, imageAry) {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;
                    self.$http.fetchWithAuth`ReplyFeedback${{
                        id: messageListId,
                        content: content,
                        imageAry: imageAry,
                    }} ${json => {
                        self.isLoading = false;
                        //console.log(`confirmBookingUrl : ${self.confirmBookingUrl}`);
                        if (json.status) {
                            self.showDialog('留言成功', false);

                            // self.selectImageAry = [];
                            self.fileList = [];
                            self.replyComment = '';
                        }
                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
                //重整畫面
                this.callFeedbackLogInfoApi(this.messageListId);
            },

            /** 捲動到底部 */
            scrollToBottom() {
                const container = document.getElementById("container");
                container.scrollTop = container.scrollHeight;
            },

            /** 點擊留言圖片 事件 */
            onClickMsgImage(imgAry, index) {
                // console.log(`onClickMsgImage: ${imgAry}`);
                //圖檔陣列轉換
                let self = this;
                if (this.$public.notNull(imgAry)) {
                    self.msgImageAry = [];
                    imgAry.forEach( item => {
                        self.msgImageAry.push(
                            {
                                url: item,
                                imgUrl: '',
                            }
                        );
                    })
                }

                this.msgImagePreviewNum = index;
                this.msgImageDialogVisible = true;

                //彈窗要改黑色背景
                document.body.classList.add('bg-dark')
            },

            /** 留言圖片預覽關閉 */
            closeMsgImageDialog(){
                this.msgImageDialogVisible = false;
                //彈窗要改回預設
                document.body.classList.remove('bg-dark')
            },

            /** 圖片預覽 */
            handlePictureCardPreview(file) {
                this.pictureCardPreviewImgIndex = this.fileList.indexOf(file);
                this.pictureCardPreviewDialogVisible = true;

                console.log(`handlePictureCardPreview: ${JSON.stringify(this.fileList)}`);
                //彈窗要改黑色背景
                document.body.classList.add('bg-dark')
            },

            /** 關閉圖片預覽 */
            closePictureCardPreviewDialog(){
                this.pictureCardPreviewDialogVisible = false;
                //彈窗要改回預設
                document.body.classList.remove('bg-dark')
            },


        },
    };
</script>

<style lang="less" scoped src="@/less/feedback.less"/>